<!-- 组队瓜分奖品 -->
<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-back
        @back="returnBack()"
        :title="['互动广场']"
        :subTitle="activityData.name"
        style="padding-bottom: 0"
      ></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="backgroundForm"
          label-width="150px"
        >
          <informationForm
            @selectPeopleSure="selectPeopleSure"
            @getMemberFn="getMemberFn"
            :defaultActMember.sync="actMember"
            :defaultActivityStartTime="activityStartTime"
            :defaultActivityEndTime="activityEndTime"
            :plusObject.sync="ruleDTO.plusObject"
            :openCardStartTime.sync="ruleDTO.openCardStartTime"
            :openCardEndTime.sync="ruleDTO.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            ref="informationForm"
            v-model="ruleForm"
            :isEdit="false"
            :disabled="activityData.isStart"
            :localStepNum="localStepNum"
            :needNonMember="true"
            :activityId="77"
            :showOpenCardTip="true"
            :objExtraTip="objExtraTip"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <!-- 活动设置 -->
          <jd-title label="活动设置"></jd-title>
          <div class="mt20">
            <!-- 加购商品 -->
            <el-form-item label="加购商品:" required>
              <!-- :disabled="activityData.isStart" -->
              <jd-button type="blueLine"  @click="addGoods">
                {{ cartItemList.length != "" ? "添加商品" + "(" + cartItemList.length + "/100" + ")" : "添加商品" }}
              </jd-button>
              <span class="ml8">C端商品排序根据下单配置的商品排序展示</span>
              <draggable v-if="cartItemList.length > 0" v-model="cartMainImagelist" chosen-class="chosen" :scroll="true"
                animation="150" force-fallback="true" @start="isDragging = true" @end="onEnd"
                style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px;" filter=".unmover">
                <transition-group type="transition">
                  <div v-for="(item, index) in cartMainImagelist" :key="item.skuId"
                    style="display: inline-block; position: relative" class="show_upImg2" :class="activityData.isStart ? 'unmover' : ''">
                    <img :src="item.logo" width="120px" height="120px" style="display: inline-block" />&nbsp;
                    <div class="delectPosible" v-if="!activityData.isStart">
                      <span class="delectSort">拖动排序</span>
                      <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg" @click.stop="delec(index)" class="delectIcom" />
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </el-form-item>

            <!-- 默认解锁商品数量 -->
            <el-form-item label="默认解锁商品数量:" prop="defaultUnlockNum" required>&nbsp;&nbsp;&nbsp;&nbsp;
              <el-input
                v-model.number="ruleForm.defaultUnlockNum"
                style="width: 150px;"
                placeholder="请输入"
                :disabled="activityData.isStart"
              ></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span style="color: #565960;">件商品(默认解锁商品数量不大于加购商品总数)</span>
            </el-form-item>

            <!-- 好友助力设置 -->
            <el-form-item label="好友助力:" required>
              <span style="color: #565960;">每邀请1位好友助力可解锁</span>&nbsp;
              <el-input
                v-model.number="ruleForm.assistUnlockNum"
                style="width: 150px;"
                placeholder="请输入"
                :disabled="activityData.isStart"
              ></el-input>&nbsp;
              <span style="color: #565960;">件商品</span>
              <div style="margin-top: 8px; color: #999; font-size: 12px;">
                <span>注: 助力成功后, 如解锁数量大于剩余待解锁商品数量时, 默认全部解锁</span>
              </div>
            </el-form-item>

            <!-- 助力限制 -->
            <el-form-item label="助力限制:" required>
              <el-radio-group v-model="ruleForm.assistLimitType" :disabled="activityData.isStart" >
                <el-radio  :label="0">仅可帮单个好友助力一次</el-radio>
                <el-radio  :label="1" style="margin-left: 20px;">可帮多个好友助力一次</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <!-- end -->

          <!-- 抽奖设置 -->
          <jd-title label="抽奖设置"></jd-title>
          <div class="mt20">
            <!-- 抽奖门槛 -->
            <el-form-item label="抽奖门槛:" prop="drawLimit" required>
              <span style="color: #565960;">成功加购</span>&nbsp;
              <el-input
                v-model.number="ruleForm.drawLimit"
                style="width: 100px;"
                placeholder="请输入"
                :disabled="activityData.isStart"
              ></el-input>&nbsp;
              <span style="color: #565960;">件商品即可抽奖，每人仅限抽奖1次</span>
            </el-form-item>

            <!-- 开奖时间 -->
            <el-form-item label="开奖时间:" prop="drawTime" required>
              <el-date-picker
                v-model="ruleForm.drawTime"
                type="datetime"
                placeholder="请选择日期"
                :disabled="activityData.isStart"
                style="width: 280px;"
              ></el-date-picker>
            </el-form-item>

            <!-- 奖品设置 -->
            <el-form-item label="奖品设置:" required>
              <div style="max-width: 1200px">
                <jd-button
                  type="blue"
                  v-if="prizeList.length < 20 && !backgroundOpacity && !activityData.isStart"
                  @click="addPrize"
                  class="mr-bt-12"
                  style="margin-bottom: 12px;"
                >添加奖品（{{ prizeList.length }}/20）</jd-button>
                <jd-table
                  :tableData="prizeList"
                >
                  <el-table-column label="奖品类型" align="center" width="120">
                    <template slot-scope="scope">
                      {{ getPrizeTypeName(scope.row.prizeType) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="奖品价值"
                    width="100"
                    prop="price"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    label="奖品图片"
                    width="100"
                  >
                    <template slot-scope="scope">
                      <img
                        v-if="scope.row.logo"
                        :src="scope.row.logo"
                        style="width: 50px; height: 50px"
                        disabled
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="奖品名称（15字内）"
                    width="220"
                  >
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.title"
                        maxlength="15"
                        :disabled="activityData.isStart"
                        show-word-limit
                        style="width: 180px"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="中奖率" width="160">
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.percentage"
                        @input="scope.row.percentage = getNumberData(1, $event, 2, 0, 100)"
                        style="width: 100px"
                        placeholder="请输入"
                        :disabled="activityData.isStart"
                      ></el-input>&nbsp;
                      <span>%</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="奖品数量" width="140">
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.totalAmount"
                        @input="scope.row.totalAmount = getNumberData(1, $event, 0, 1, 999999)"
                        style="width: 100px"
                        placeholder="请输入"
                        :disabled="activityData.isStart"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="每日发放限额" width="120">
                    <template slot-scope="scope">
                      <dailyLimitConfig
                        :row="scope.row"
                        :backgroundOpacity="backgroundOpacity"
                        :limitBtnDisabled="backgroundOpacity"
                      ></dailyLimitConfig>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" min-width="200">
                    <template slot-scope="scope">
                      <div class="flex-center">
                        <jd-button
                          type="blueText"
                          :disabled="backgroundOpacity || activityData.isStart"
                          @click="selectPrize(scope)"
                        >选择奖品</jd-button>
                        <el-upload
                          class="label-left"
                          action="/jd-hd-web/image/upload"
                          :show-file-list="false"
                          :before-upload="beforeUpload"
                          :on-success="(res) => handlePrizeUpload(res, scope.row)"
                          :disabled="backgroundOpacity || activityData.isStart"
                        >
                          <jd-button
                            type="blueText"
                            style="margin-right: 8px;margin-left: 8px"
                            :disabled="backgroundOpacity || activityData.isStart"
                          >上传图片</jd-button>
                        </el-upload>
                        <jd-button
                          v-if="prizeList.length > 1"
                          type="blueText"
                          :disabled="backgroundOpacity || activityData.isStart"
                          @click="deletePrize(scope.$index)"
                        >删除</jd-button>
                        <jd-button
                          type="blueText"
                          style="margin-left: 5px"
                          v-if="activityData.isStart && scope.row.title"
                          @click="addStock(scope, 0)"
                        >增加奖品数量</jd-button>
                      </div>
                    </template>
                  </el-table-column>
                </jd-table>
                <div style="margin-top: 10px; color: #999; font-size: 12px;">
                  <span>注: 所有奖品中奖率相加不得大于100%，如某一奖品库存空时，概率自动分配为【谢谢参与】</span>
                </div>
              </div>
            </el-form-item>

            <!-- 开奖配置 -->
            <el-form-item label="开奖配置:" prop="lotteryConfig">
              <el-radio-group v-model="ruleForm.lotteryConfig" :disabled="activityData.isStart">
                <el-radio :label="0">到达开奖时间自动开奖</el-radio>
                <el-radio :label="1" style="margin-left: 20px;">手动抽奖（到达开奖时间由C端用户需进入活动进行抽奖）</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>

          <!-- end -->

          <activityPageSettings
            isShowShopName
            :cusTemplateJSON.sync="ruleDTO.cusTemplateJSON"
            :isNeedSetBG="true"
            :giftList="giftList"
            :templateId="templateId"
            @selectTemplate="selectTemplate"
            @cusTemplateJSONChange="handleBgImageChange"
            :widthNumber="750"
            :heightNumber="1624"
            previewKey="url"
            templatekey="imageUrl"
            :isShowDesignNumber="false"
            :isCustomPreview="true"
            :defaultRgb="currrentRgb"
            :isNeedCustomerPaperworkData="false"
            designSpecificationsUrl="https://cdn-image.yucrm.cn/hd/images/jl.png"
            downloadTemplateUrl="https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/gwc.psd"
            v-model="customerPaperwork"
          >
            <template #customPreview>
              <shoppingCartKoiPreview
                :prizeList="prizeList"
                :cartItemList="cartItemList"
                :defaultUnlockNum="ruleForm.defaultUnlockNum"
                :drawLimit="ruleForm.drawLimit"
                :mainButtonBgImage="customerPaperwork.memberBtnUrl"
                :mainButtonTextColor="customerPaperwork.memberBtnWordColor || templateObj.rgb2"
                :bgImage="uploadBgImage || templateObj.url"
                :titleColor="customerPaperwork.titleColor"
              ></shoppingCartKoiPreview>
            </template>
            <template #otherSet>
              <div class="ui-box">
                <el-form-item label="主按钮背景图：" label-width="158px">
                  <div class="buttonGroup">
                    <el-upload
                      class="upload"
                      action="/jd-hd-web/image/upload"
                      :show-file-list="false"
                      :before-upload="(file) => beforeUploadUI(file, 2)"
                      :on-success="(res) => handleUploadUI(res, 2)"
                    >
                      <div class="btn-bg" v-if="customerPaperwork.memberBtnUrl">
                        <img
                          :src="customerPaperwork.memberBtnUrl"
                          style="width: 100%; height: auto"
                        />
                      </div>
                      <jd-button
                        v-else
                        type="blueText"
                        label="自定义上传"
                        :disabled="backgroundOpacity"
                      ></jd-button>
                    </el-upload>
                    <jd-button
                      type="blueText"
                      @click="customerPaperwork.memberBtnUrl = ''"
                      style="margin: 0 16px 0 16px"
                      :disabled="backgroundOpacity"
                      >重置</jd-button
                    >
                  </div>
                </el-form-item>
                <el-form-item label="主按钮文案颜色：" label-width="158px">
                  <div class="buttonGroup">
                    <el-color-picker
                      v-model="customerPaperwork.memberBtnWordColor"
                      size="small"
                    ></el-color-picker>
                    <jd-button
                      type="blueText"
                      style="margin: 0 12px 0 16px"
                      @click="customerPaperwork.memberBtnWordColor = currrentRgb3"
                      :disabled="backgroundOpacity"
                      >重置</jd-button
                    >
                  </div>
                </el-form-item>
              </div>
            </template>
          </activityPageSettings>

          <jd-title label="进店设置" type="bold"></jd-title>
          <el-form-item label="进店逛逛:">
            <el-radio-group
              v-model="ruleDTO.goShopSetting"
              :disabled="activityData.isStart"
              @change="onShopSetChange"
            >
              <el-radio :label="0">进入店铺首页</el-radio>
              <el-radio :label="1">跳转指定小程序</el-radio>
              <el-radio :label="2">进入指定链接</el-radio>
            </el-radio-group>
            <div style="color: #f56c6c">
              部分活动需要配合曝光商品使用，如幸运抽奖、裂变神券
            </div>
          </el-form-item>
          <div v-if="ruleDTO.goShopSetting == 1">
            <el-form-item label="小程序appId:" required>
              <el-input
                type="textarea"
                placeholder="请输入小程序appId"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopAppId"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
            </el-form-item>
            <el-form-item label="页面路径path:">
              <el-input
                type="textarea"
                placeholder="请输入小程序页面路径path"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopUrl"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
              <div style="color: #f56c6c">
                注意：path若不写，则默认进入小程序主页。
              </div>
            </el-form-item>
          </div>
          <el-form-item
            label="指定链接:"
            required
            v-if="ruleDTO.goShopSetting == 2"
          >
            <el-input
              type="textarea"
              placeholder="请输入指定链接"
              style="width: 425px; margin-left: 8px"
              show-word-limit
              v-model="ruleDTO.goShopUrl"
              :maxlength="1000"
              :disabled="activityData.isStart"
            ></el-input>
            <div style="color: #f56c6c">
              注意：仅可填写京东域内的
              H5页面地址，不可设置外链。参考链接：https://m.jd.com/。
            </div>
          </el-form-item>
          <!-- <exposureList
            :defaultExposureSwitch.sync="ruleForm.isExposureItem"
            v-model="itemListFor"
            :backgroundOpacity="backgroundOpacity"
            :isLimit="true"
          ></exposureList> -->
          <sharFrom :sharePic="sharePic" v-model="ruleDTO"></sharFrom>
          <activityRules
            :needIsForceRemind="false"
            :isForceRemind.sync="ruleDTO.isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            :activityData="activityData"
            :valueRow="valueRow"
            v-model="ruleForm.ruleDescription"
            @generateRule="generateRule"
          ></activityRules>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button
        v-if="localStepNum != 0"
        v-show="!itemId"
        style="margin-right: 8px"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button
          v-show="!itemId"
          v-if="isSave"
          type="blue"
          @click="resetForm"
          v-preventReClick
          >保存设置</jd-button
        >
      </template>

      <jd-button v-show="itemId" style="margin-right: 8px" @click="cancelEdit"
        >取消</jd-button
      >
      <jd-button v-show="itemId" type="blue">保存设置</jd-button>
    </div>

    <!-- 保存设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div v-loading="saveLoading">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>

        <el-checkbox v-model="checked" label="地址" name="partner"
          >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          v-loading="saveLoading"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
    <!-- 奖品弹窗 -->
    <selectProduct
      ref="selectProduct"
      v-if="isShowPrize || showSelectProduct"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :typeDefault="typeDefault"
      :actType="77"
      :actEndTime="ruleForm.endTime"
      @choose-shop="getTheData"
    >
    </selectProduct>
    <!-- 复购奖品弹窗 -->
    <selectProduct
      ref="selectStepProduct"
      v-if="isShowStepPrize"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :typeDefault="typeDefault"
      @choose-shop="getStepTheData"
    >
    </selectProduct>
    <!-- 专享价 -->
    <selectSpecialDialog
      v-if="isShowExclusive"
      v-model="isShowExclusive"
      :exclusivePriceId="promotionId"
      @confirm="confirmExclusiveOrToken"
    ></selectSpecialDialog>
    <!-- 试用商品 -->
    <selectGoods
      v-if="isShowTrial"
      :isShow="isShowTrial"
      @close="getTrialProduct"
      :selectGoods="trialProduct"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="true"
      :limitNum="10"
      :disabled="backgroundOpacity"
    >
    </selectGoods>
    <!--试用正装： 购买指定商品 -->
    <selectGoods
      v-if="isShowSpecified"
      :isShow="isShowSpecified"
      @close="getSpecifiedProduct"
      :selectGoods="specifiedProduct"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="true"
      :limitNum="1"
      :disabled="backgroundOpacity"
    >
    </selectGoods>
    <!-- 会员首购：指定商品 -->
    <selectGoods
      v-if="isShowSpecify"
      :isShow="isShowSpecify"
      @close="getSpecifyOrExcludeGoods"
      :selectGoods="specifyOrExcludeGoods"
      :hasSelectGoods="hasSelectGoods"
      :isClear="activityData.isStart"
      :moduleType="true"
      :skuSearch="true"
      :disabled="backgroundOpacity"
    ></selectGoods>
    <!-- 复购阶段：指定商品 -->
    <selectGoods
      v-if="isShowStepSpecify"
      :isShow="isShowStepSpecify"
      @close="getStepSpecifyOrExcludeGoods"
      :selectGoods="stepspecifyOrExcludeGoods"
      :moduleType="true"
      :skuSearch="true"
      :disabled="backgroundOpacity"
    ></selectGoods>
    <!-- 选择令牌弹窗 -->
    <selectTokenDialog
      v-if="isShowToken"
      v-model="isShowToken"
      :tokenId="promotionId"
      @confirm="confirmExclusiveOrToken"
      :isSetDisabled="true"
    ></selectTokenDialog>
    <!-- 自定义计量单位-首购 -->
    <select-unit-goods
      v-if="isShowSelectUnitGoods"
      :skuSearch="true"
      :isShow="isShowSelectUnitGoods"
      :moduleType="true"
      :selectGoods="specifyOrExcludeGoods"
      :measureUnitId="purchaseOrderConfig.orderRuleConfig.statisticType"
      @close="getSpecifyOrExcludeGoods"
    ></select-unit-goods>
    <!-- 自定义计量单位-复购 -->
    <select-unit-goods
      v-if="isShowSelectUnitGoods2"
      :skuSearch="true"
      :isShow="isShowSelectUnitGoods2"
      :moduleType="true"
      :selectGoods="stepspecifyOrExcludeGoods"
      :measureUnitId="stepspecifyItem.orderRuleConfig.statisticType"
      @close="getStepSpecifyOrExcludeGoods"
    ></select-unit-goods>
    <!-- 添加曝光商品 -->
    <selectGoodsMonitor v-if="selectGoodsState" :disabled="backgroundOpacity" ref="selectGo" :isShow="selectGoodsState" @close="selectGoodsClose"
      :selectGoods="selectGoodsArr" :moduleType="true" :skuSearch="true" :xianz="true" :numlimit="numlimit" :isShowDesc="activityData.isStart">
    </selectGoodsMonitor>
  </div>
</template>

<script>
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
import selectGoods from "@/components/selectGoodsMonitor2";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2";
import selectUnitGoods from "@/views/interactiveMarketing/activity/components/selectUnitGoods.vue";
import selectProduct from "./select_product_componentization.vue";
import {
  saveOrUpdateShoppingCartKoi,
  getShoppingCartKoiDetail,
  getActivityDetailCommon
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import { sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import draggable from "vuedraggable";
import addPrizeNum from "./components/add-prize-num.vue";
import setLimitDialog from "@/views/interactiveMarketing/activity/components/_components/setLimitDialog.vue";
import informationForm from "./components/informationForm.vue";
import exposureList from "./components/exposureList.vue";
import sharFrom from "./components/sharFrom.vue";
import activityRules from "./components/activityRules.vue";
import activityPageSettings from "./components/activityPageSettings.vue";
import addTaskDialog from "./components/unlock_task_dialog.vue";
import shoppingCartKoiPreview from "./components/shoppingCartKoiPreview.vue";
import selectSpecialDialog from "./components/selectSpecialDialog.vue";
import selectTokenDialog from "@/views/interactiveMarketing/promo/components/selectTokenDialog.vue";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import { getSkuList } from "@/api/member/pointsManagement.js"
// import { useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";

import {
  measureUnitPage,
  unitSkuPage
} from "@/api/measuringUnit.js";
export default {
  components: {
    selectGoods,
    selectGoodsMonitor,
    selectProduct,
    draggable,
    addPrizeNum,
    setLimitDialog,
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    addTaskDialog,
    shoppingCartKoiPreview,
    selectSpecialDialog,
    selectTokenDialog,
    selectUnitGoods,
    dailyLimitConfig,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    venderType: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.purchaseOrderConfig.orderRuleConfig.orderPaymentType = 1;
          this.repurchaseStages.forEach((item) => {
            item.orderRuleConfig.orderPaymentType = 1;
          });
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      isShowSelectUnitGoods2: false,
      stepspecifyItem: {},
      isShowSelectUnitGoods: false,
      isSignLimitTime: false, // 报名限制时间
      currentId: null,
      defaultLogo: "https://cdn-image.yucrm.cn/hd/images/prizeShow646.png",
      isShowPrize: false,
      echoDate: {},
      tableIndex: -1,
      prizeIndex: 0,
      currentIndex: 0,
      objExtraTip: "",
      itemArr: [],
      saveLoading: false,
      showSelectProduct: false,
      JingdouCount: {
        prizeCount: 0,
      },
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      toAddItem: null,
      isShowAddNum: false,
      loading: false,
      templateObj: {},
      currrentRgb: "#191919",
      currrentRgb2: "#ffffff",
      currrentRgb3: "#ffffff",
      currrentRgb4: "#ffffff",
      currrentRgb5: "#ffffff",
      currrentRgb6: "#191919",
      currrentRgb7: "#ffffff",
      customerPaperwork: {
        memberModelUrl: "",
        memberBtnUrl: "",
        memberBtnWordColor: "",
      },
      uploadBgImage: "", // 存储上传的背景图
      actMember: "1",
      peopleSelected: [],
      templateId: "",
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      itemListFor: [], //曝光商品列表
      cartItemList: [], //加购商品列表
      cartMainImagelist: [], //加购商品拖拽列表
      isDragging: false, //是否正在拖拽
      selectGoodsState: false, //是否显示选择商品弹窗
      selectGoodsArr: [], //已选择加购商品列表
      numlimit: 100, //加购商品数量限制
      currentPrizeIndex: -1, // 当前选中奖品索引
      selectPrizeState: false, // 是否显示选择奖品弹窗
      venderType: false, // 是否是供应商类型
      joinBlackList: false,
      checked: false,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      ruleForm: {
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        allowLevel: "-1",
        activityName: "",
        openCardFollow: 0,
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "",
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: "", // 最小订单笔数
        orderCompleteMaxCount: "", // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: "", // 最小订单金额
        orderCompleteMaxPayment: "", // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: "", // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: "", // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: "", // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: "", // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)
        joinStartTime: "", // 报名开始时间
        joinEndTime: "", // 报名结束时间
        applyLimitNum: "", // 报名人数限制
        defaultUnlockNum: "", // 默认解锁商品数量
        assistUnlockNum: "", // 每邀请1位好友助力可解锁商品数量
        assistLimitType: 0, // 助力限制类型: 0-仅可帮单个好友助力一次, 1-可帮多个好友助力一次
        drawLimit: "", // 抽奖门槛：成功解锁多少件商品可抽奖
        drawTime: "", // 开奖时间
        lotteryConfig: 0, // 开奖配置：1-自动开奖，2-手动抽奖
      },
      ruleDTO: {
        customerPaperwork: "",
        cusTemplateJSON: "",
        plusObject: 0,
        goShopSetting: 0,
        goShopAppId: "",
        goShopUrl: "",
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        openCardStartTime: "",
        openCardEndTime: "",
        activityScene: 1,
        isForceRemind: false,
      },
      isKeyActivity: 0,
      placementPosition: [],
      prizeList: [{
        prizeType: "",
        price: "",
        title: "",
        totalAmount: "",
        logo: "",
        percentage: "",
      }], //奖品设置
      sharePic: "",
      activityStartTime: null,
      activityEndTime: null,
      templateJson: {
        templateUItype: "",
      },

      levelList: [],
      isDraft: false,
      //下单时间限制
      orderPickerOptionsStart: {
        disabledDate: (time) => {
          if (this.purchaseOrderConfig.orderTimeConfig.endTime) {
            return (
              time.getTime() >
              new Date(
                this.purchaseOrderConfig.orderTimeConfig.endTime
              ).getTime()
            );
          }
          return false;
        },
      },
      orderPickerOptionsEnd: {
        disabledDate: (time) => {
          if (
            this.purchaseOrderConfig.orderTimeConfig.startTime ||
            this.ruleForm.endTime
          ) {
            return (
              time.getTime() <
                new Date(
                  this.purchaseOrderConfig.orderTimeConfig.startTime
                ).getTime() ||
              time.getTime() > new Date(this.ruleForm.endTime).getTime()
            );
          }
          return false;
        },
      },
      //下单时间限制
      stageOrderPickerOptionsStart: {
        disabledDate: (time) => {
          let row = this.repurchaseStages[this.rankValue];
          if (row.orderTimeConfig.endTime) {
            return (
              time.getTime() > new Date(row.orderTimeConfig.endTime).getTime()
            );
          }
          return false;
        },
      },
      stageOrderPickerOptionsEnd: {
        disabledDate: (time) => {
          let row = this.repurchaseStages[this.rankValue];
          if (row.orderTimeConfig.startTime || this.ruleForm.endTime) {
            return (
              time.getTime() <
                new Date(row.orderTimeConfig.startTime).getTime() ||
              time.getTime() > new Date(this.ruleForm.endTime).getTime()
            );
          }
          return false;
        },
      },
      pickerOptionApplyStart: {
        disabledDate: (time) => {
          if (this.ruleForm.endTime && this.ruleForm.startTime) {
            return (
              time.getTime() > new Date(this.ruleForm.endTime).getTime() ||
              time.getTime() <
                new Date(this.ruleForm.startTime).getTime() -
                  24 * 60 * 60 * 1000
            );
          } else {
            return false;
          }
        }
      },
      pickerOptionApplyEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.endTime && this.ruleForm.startTime) {
            return (
              time.getTime() > new Date(this.ruleForm.endTime).getTime() ||
             (time.getTime() < (new Date(this.ruleForm.startTime).getTime() - 24 * 60 * 60 * 1000 )) || (time.getTime() < (new Date(this.ruleForm.joinStartTime).getTime() - 24 * 60 * 60 * 1000))
            );
          } else {
            return false;
          }
        },
      }
    };
  },
  computed: {
    // 自定义单位名称
    purchaseOrderUnitName() {
      if(this.unitList.length > 0 && this.purchaseOrderConfig.orderRuleConfig.statisticType != 0) {
        const item = this.unitList.find(v=> v.id == this.purchaseOrderConfig.orderRuleConfig.statisticType)
        if(item) {
          return item.name
        } else {
          return ""
        }
      } else {
        return ""
      }
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
  },
  created() {
    this.sharePic = this.getDefaultSharePic(77);
    this.ruleDTO.sharePic = this.sharePic;
    this.ruleDTO.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDTO.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
    this.getmeasureUnitPage();
  },
  mounted() {
    this.getLevel();
    this.getDetail();
    this.buriedPoint(1, "购物车锦鲤", "互动管理", "互动活动");
  },

  methods: {
    // 日期格式化
    formatDate(date, fmt = "yyyy-MM-dd hh:mm:ss") {
      let currentDate = new Date(date);
      let o = {
        "M+": currentDate.getMonth() + 1,
        "d+": currentDate.getDate(),
        "h+": currentDate.getHours(),
        "m+": currentDate.getMinutes(),
        "s+": currentDate.getSeconds(),
        "q+": Math.floor((currentDate.getMonth() + 3) / 3),
        S: currentDate.getMilliseconds(),
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (currentDate.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    },
    // 添加加购商品弹窗
    addGoods() {
      this.selectGoodsState = true;
      this.numlimit = 50
      if (this.cartItemList.length == 0) {
        this.cartItemList = [];
        this.cartMainImagelist = [];
        this.selectGoodsArr = [];
      } else {
        this.selectGoodsArr = this.cartItemList;
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },
    // 删除加购商品
    delec(index) {
      this.cartMainImagelist.splice(index, 1);
      this.cartItemList.splice(index, 1);
    },
    // 添加奖品
    addPrize() {
      this.prizeList.push({
        prizeType: "",
        price: "",
        title: "",
        totalAmount: "",
        logo: "",
        percentage: "",
      });
    },
    // 删除奖品
    deletePrize(index) {
      this.prizeList.splice(index, 1);
    },
    // 选择奖品
    selectPrize(scope) {
      this.tableIndex = scope.$index;
      this.echoDate = scope.row;
      this.showSelectProduct = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    // 奖品图片上传成功处理
    handlePrizeUpload(res, row) {
      if (res.code === 1) {
        row.logo = res.data;
      }
    },
    // 获取奖品类型名称
    getPrizeTypeName(type) {
      const typeMap = {
        1: "优惠券",
        2: "京豆",
        3: "实物",
        4: "店铺积分",
        5: "京东E卡",
        6: "爱奇艺会员",
        7: "京东PLUS会员",
        8: "现金红包",
        9: "谢谢参与",
        10: "礼品卡",
        12: this.venderType ? "令牌" : "专享价",
        14: "实物（随单发）",
      };
      return typeMap[type] || "";
    },
    // 加购商品图片拖拽结束
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.cartMainImagelist.forEach((item) => {
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    // 选择加购商品弹窗关闭
    selectGoodsClose(data) {
      if (data) {
        this.cartItemList = [];
        this.cartMainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].skuName || data[index].title;
          this.cartItemList.push(fomeVaule);
          this.cartMainImagelist.push(fomeVaule);
        });
        this.selectGoodsArr = this.cartItemList;
      }
      this.selectGoodsState = false;
    },
    changeParticipateType(type) {
      this.isSignLimitTime = false; // 报名限制
      this.ruleForm.joinStartTime = "";
      this.ruleForm.joinEndTime = "";
    },
    applyBlur(time,type) {
      if(type=='start') {
        if(!time.value) {
          this.$message.warning("请选择报名开始时间");
        }
      } else if(type=='end') {
        if(!time.value) {
          this.$message.warning("请选择报名结束时间");
        }
      }
    },
    applyTimeChange() {
      let applyStart = new Date(this.ruleForm.joinStartTime).valueOf();
      let applyEnd = new Date(this.ruleForm.joinEndTime).valueOf();
      if(!this.ruleForm.startTime&&!this.ruleForm.endTime) {
        this.$message.warning("请先选择活动时间");
        this.ruleForm.joinStartTime = "";
        this.ruleForm.joinEndTime = "";
        return
      }
      if (applyStart > applyEnd) {
        this.$message.warning("报名开始时间不可晚于结束时间");
        this.ruleForm.joinEndTime = "";
      }
    },
    changeRepurchaseStatisticType(val,row) {
      if(val != 0){
        row.orderRuleConfig.filterType = 1;
      } else {
        row.orderRuleConfig.filterType = 0;
      }
      row.orderRuleConfig.skuIdList = [];
    },
    changePurchaseOrderStatisticType(val){
      if(val != 0){
        this.purchaseOrderConfig.orderRuleConfig.filterType = 1;
      } else {
        this.purchaseOrderConfig.orderRuleConfig.filterType = 0;
      }
      this.specifyOrExcludeGoods = [];
    },
    goToMeasureUnit(){
      let routeUrl = this.$router.resolve({
        path: "/interactiveMarketing/interactiveMeasure_Unit"
      });
      window.open(routeUrl.href, "_blank");
    },
    // 获取自定义单位
    getmeasureUnitPage(){
      let data = {
        venderId:this.venderId,
        size:9999,
        current:1,
      }
      measureUnitPage(data).then(res=>{
        if(res.code == 1){
          const list = res.data.records || []
          this.unitList = list.filter(v=> v.status == 1)
        }
      })
    },
    handlePrizeConfigChange(val) {
      if(val==1) {
        this.purchaseOrderConfig.prizeConfig.sendType = 0;
        this.purchaseOrderConfig.prizeConfig.delayDays = "";
        this.purchaseOrderConfig.prizeConfig.delayDays2 = "";
        this.prizeList = [
          {
            orderAmtLimit: null,
            specifiedProduct: [],
            goodsList: [
              {
                assetsId: "",
                title: "",
                logo: "",
                prize: "",
                prizeType: null,
                totalAmount: null,
              },
            ],
          },
          {
            orderAmtLimit: null,
            specifiedProduct: [],
            goodsList: [
              {
                assetsId: "",
                title: "",
                logo: "",
                prize: "",
                prizeType: null,
                totalAmount: null,
              },
            ],
          },
        ];
      }
    },
    changeExclusivePrice(val) {
      if (!val) {
        this.firstStageConfig.exclusivePriceConfig.joinDays = "";
        this.promotionList = [
          {
            assetsId: null, // 资产项id(计划id优惠卷id商品id)
            prizeType: null,
            price: null,
            logo: null,
            title: "",
            totalAmount: null,
          },
        ];
        this.designatedSku = [];
      }
    },
    changeFirstPurchase(val) {
      if (!val) {
        this.purchaseOrderConfig.orderTimeConfig.timeType = 1;
        this.purchaseOrderConfig.orderTimeConfig.joinDays = "";
        this.purchaseOrderConfig.orderTimeConfig.startTime = "";
        this.purchaseOrderConfig.orderTimeConfig.endTime = "";
        this.purchaseOrderConfig.orderRuleConfig.orderPaymentType = this
          .venderType
          ? 1
          : 0;
        this.purchaseOrderConfig.orderRuleConfig.filterType = 0;
        this.specifyOrExcludeGoods = [];
        this.purchaseOrderConfig.prizeConfig.enabled = false;
        this.purchaseOrderConfig.prizeConfig.sendType = 0;
        this.purchaseOrderConfig.prizeConfig.delayDays = "";
        this.purchaseOrderConfig.prizeConfig.delayDays2 = "";
        this.prizeList = [
          {
            orderAmtLimit: null,
            specifiedProduct: [],
            goodsList: [
              {
                assetsId: "",
                title: "",
                logo: "",
                prize: "",
                prizeType: null,
                totalAmount: null,
              },
            ],
          },
          {
            orderAmtLimit: null,
            specifiedProduct: [],
            goodsList: [
              {
                assetsId: "",
                title: "",
                logo: "",
                prize: "",
                prizeType: null,
                totalAmount: null,
              },
            ],
          },
        ];
      }
    },
    changeOrderTime(val, item) {
      if (val == 2) {
        item.joinDays = "";
      } else {
        item.startTime = "";
        item.endTime = "";
      }
    },
    changeTimeType(val) {
      if (val == 2) {
        this.purchaseOrderConfig.orderTimeConfig.joinDays = "";
      } else {
        this.purchaseOrderConfig.orderTimeConfig.startTime = "";
        this.purchaseOrderConfig.orderTimeConfig.endTime = "";
      }
    },
    handleSendTypeChange(val) {
      if (val == 0) {
        this.purchaseOrderConfig.prizeConfig.delayDays = null;
        this.purchaseOrderConfig.prizeConfig.delayDays2 = null;
      } else if (val != 1) {
        this.purchaseOrderConfig.prizeConfig.delayDays = null;
      } else if (val != 2) {
        this.purchaseOrderConfig.prizeConfig.delayDays2 = null;
      }
    },
    addRepurchaseStock(scope, index, it) {
      this.toAddItem = {
        ...scope.row,
        num: scope.row.totalAmount,
      };
      this.currentPrizeIndex = it;
      this.stockIndex = index;
      this.isShowAddNum = true;
      this.stockPrizeIndex = scope.$index;
    },
    addStock(scope, index) {
      this.toAddItem = {
        ...scope.row,
        num: scope.row.totalAmount,
      };
      this.stockIndex = index;
      this.isShowAddNum = true;
      this.stockPrizeIndex = scope.$index;
    },
    changeStepSendType(val, item) {
      if (val == 0) {
        item.delayDays = null;
        item.delayDays2 = null;
      } else if (val != 1) {
        item.delayDays = null;
      } else if (val != 2) {
        item.delayDays2 = null;
      }
    },
    changeFilterType(row) {
      row.skuIdList = [];
      this.stepspecifyOrExcludeGoods = [];
    },
    clearStageTime(item) {
      item.startTime = "";
      item.endTime = "";
    },
    clearTime() {
      this.purchaseOrderConfig.orderTimeConfig.startTime = "";
      this.purchaseOrderConfig.orderTimeConfig.endTime = "";
    },
    clearApplyTime() {
      this.ruleForm.joinStartTime = "";
      this.ruleForm.joinEndTime = "";
    },
    stageNameSet() {
      if (this.ruleDTO.activityScene == 1) {
        this.repurchaseStages.forEach((item, index) => {
          item.stageName = `第${index + 1}次复购`;
        });
      } else {
        this.repurchaseStages.forEach((item, index) => {
          if (index == 0) {
            item.stageName = `首购礼`;
          } else {
            item.stageName = `第${index}次复购`;
          }
        });
      }
    },
    addRePurchaseStage() {
      if (this.repurchaseStages.length >= 10) {
        this.$message.warning("最多只能配置10个复购阶段");
        return;
      }
      this.repurchaseStages.push({
        stageName: "",
        orderTimeConfig: {
          timeType: 1,
          joinDays: null,
          startTime: "",
          endTime: "",
        },
        orderRuleConfig: {
          orderPaymentType: this.venderType ? 1 : 0,
          filterType: 0,
          skuIdList: [],
          statisticType: 0,
        },
        prizeConfig: {
          sendType: true,
          sendType: 0,
          delayDays: null,
          delayDays2: null,
        },
        stepPrizeList: [
          {
            orderAmtLimit: null,
            goodsList: [
              {
                assetsId: "",
                title: "",
                logo: "",
                prize: "",
                prizeType: null,
                totalAmount: null,
              },
            ],
          },
          {
            orderAmtLimit: null,
            goodsList: [
              {
                assetsId: "",
                title: "",
                logo: "",
                prize: "",
                prizeType: null,
                totalAmount: null,
              },
            ],
          },
        ],
      });
      this.stageNameSet();
    },
    removeRank(index) {
      if (this.repurchaseStages.length <= 1) {
        this.$message.warning("最少需配置一个复购阶段");
        return;
      }
      if (this.activityData.isStart || this.backgroundOpacity) {
        return;
      }
      this.repurchaseStages.splice(index, 1);
      this.stageNameSet();
      if (index == this.rankValue) {
        this.rankValue = index == 0 ? "0" : index - 1 + "";
      } else if (index < this.rankValue) {
        this.rankValue = this.rankValue - 1 + "";
      }
    },
    deleteStepPrize(index) {
      this.prizeList.splice(index, 1);
    },
    deleteRepurchasePrize(row, index) {
      row.stepPrizeList.splice(index, 1);
    },
    selectSpecifiedProduct(index) {
      this.currentIndex = index;
      this.specifiedProduct = this.prizeList[index].specifiedProduct;
      this.isShowSpecified = true;
    },
    deleteSpecifiedPrize(specifiedProduct, index) {
      specifiedProduct.splice(index, 1);
    },
    addPrizeSetting() {
      if (this.prizeList.length >= 5) {
        this.$message({
          message: "最多只能添加5个奖品设置",
          type: "warning",
        });
        return;
      }
      this.prizeList.push({
        orderAmtLimit: null,
        specifiedProduct: [],
        goodsList: [
          {
            assetsId: "",
            title: "",
            logo: "",
            prize: "",
            prizeType: null,
            totalAmount: null,
          },
        ],
      });
    },
    addStepPrizeSetting(row) {
      if (row.stepPrizeList.length >= 5) {
        this.$message({
          message: "最多只能添加5个奖品设置",
          type: "warning",
        });
        return;
      }
      row.stepPrizeList.push({
        orderAmtLimit: null,
        goodsList: [
          {
            assetsId: "",
            title: "",
            logo: "",
            prize: "",
            prizeType: null,
            totalAmount: null,
          },
        ],
      });
    },
    selectGoodFn(goodsList, index, scope) {
      this.currentIndex = index;
      this.prizeIndex = scope.$index;
      this.JingdouCount.prizeCount = scope.row.totalAmount;
      this.echoDate = scope.row;
      this.itemArr = goodsList;
      this.isShowPrize = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    selectRepurchaseGoodFn(goodsList, it, scope) {
      this.stepPrizeIndex = it;
      this.JingdouCount.prizeCount = scope.row.totalAmount;
      this.echoDate = scope.row;
      this.itemArr = goodsList;
      this.isShowStepPrize = true;
      this.$nextTick(() => {
        this.$refs.selectStepProduct.openDialog();
      });
    },
    openGoods() {
      this.isShowSpecify = true;
    },
    openStepSpecify(list,item) {
      this.stepspecifyItem = item;
      this.stepspecifyOrExcludeGoods = list
      if(item.orderRuleConfig.statisticType == 0) {
        this.isShowStepSpecify = true;
      } else {
        this.isShowSelectUnitGoods2 = true;
      }
    },
    getSpecifyOrExcludeGoods(data) {
      if (data && data.length > 0) {
        this.specifyOrExcludeGoods = data;
        this.purchaseOrderConfig.orderRuleConfig.skuIdList = data.map(
          (item) => item.skuId
        );
      }
      this.isShowSpecify = false;
      this.isShowSelectUnitGoods = false;
    },
    getStepSpecifyOrExcludeGoods(data) {
      if (data && data.length > 0) {
        this.stepspecifyOrExcludeGoods = [];
        this.repurchaseStages[this.rankValue].orderRuleConfig.skuIdList = []
        data.forEach((item) => {
          let obj = {
            skuId: "",
            skuName: "",
            logo: "",
            price: "",
          };
          obj.skuId = item.skuId;
          obj.title = item.wareTitle || item.title;
          obj.logo = item.logo;
          obj.price = item.jdPrice;
          this.stepspecifyOrExcludeGoods.push(obj);
          this.repurchaseStages[this.rankValue].orderRuleConfig.skuIdList.push(obj)
        });
      }
      this.isShowStepSpecify = false;
      this.isShowSelectUnitGoods2 = false;
    },
    getTrialProduct(data) {
      if (data.length > 0) {
        this.trialProduct = [];
        data.forEach((item) => {
          let obj = {
            skuId: "",
            skuName: "",
            logo: "",
            price: "",
          };
          obj.skuId = item.skuId;
          obj.title = item.wareTitle || item.title;
          obj.logo = item.logo;
          obj.price = item.jdPrice;
          this.trialProduct.push(obj);
        });
      }
      this.isShowTrial = false;
    },
    getSpecifiedProduct(data) {
      if (data.length > 0) {
        let arr = [];
        data.forEach((item) => {
          let obj = {
            skuId: "",
            skuName: "",
            logo: "",
            price: "",
          };
          obj.skuId = item.skuId;
          obj.title = item.wareTitle || item.title;
          obj.logo = item.logo;
          obj.price = item.jdPrice;
          arr.push(obj);
        });
        this.$set(this.prizeList[this.currentIndex], "specifiedProduct", arr);
      }
      this.isShowSpecified = false;
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let type = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();
        let sorts = [".png", ".jpg"];
        if (sorts.indexOf(type) < 0) {
          reject();
          this.$message.info("所选图片格式不符，请重新选择");
        } else {
          let image = new Image();
          let _URL = window.URL || window.webkitURL;
          image.onload = function () {
            const valid = image.width == width && image.height == height;
            file.isFlag = valid;
            if (valid) {
              resolve(true);
            } else {
              _this.$message.info("图片尺寸不符合要求，请重新上传");
              reject();
            }
          };
          image.src = _URL.createObjectURL(file);
        }
      });
    },
    async beforeUploadPrize(file) {
      const status = await this.imgchecked(file, 200, 200);
      if (!status) {
        return false;
      }
    },
    uploadLogo(val) {
      this.designatedSku[0].logo = val.data;
    },
    // 确认专享价
    confirmExclusiveOrToken(val) {
      console.log(val,'544444',this.priceObj.jdPrice);
      const currentTotalAmount = this.promotionList[0] && this.promotionList[0].totalAmount || "";
      this.promotionList = [];
      this.designatedSku = [];
      if (this.venderType) {
        this.priceObj = {
          ...val.detailList[0].promoSkuList[0],
          id: val.tokenId,
        };
      } else {
        this.priceObj = {
          ...val.skuList[0],
          id: val.id,
        };
      }
      console.log(this.priceObj,'544444');
      this.promotionList.push({
        assetsId: this.priceObj.id,
        prizeType: 12,
        price: val.minPayPrice,
        title: val.name,
        totalAmount: currentTotalAmount,
        logo: "https://cdn-image.yucrm.cn/96a42448b954472ebdc825c4d4af7268.png",
        prizeObjectType: 0,
        id: this.activityData.isStart ? this.currentId : null,
      });
      this.designatedSku.push({
        planId: this.priceObj.id,
        skuId: this.priceObj.skuId,
        skuName: this.priceObj.skuName,
        logo: this.priceObj.logo,
        jdPrice: this.priceObj.jdPrice,
        exclusivePrice: this.venderType ? (this.activityData.isStart ? this.designatedSkuCopy[0].exclusivePrice : "") : this.priceObj.payPrice,
      });
      this.isShowExclusive = false
      this.isShowToken =false
    },
    selectPromotion(row) {
      this.currentId = row.id;
      if (this.venderType) {
        this.isShowToken = true;
      } else {
        this.isShowExclusive = true;
      }

      if (row.assetsId) {
        this.promotionId = row.assetsId;
      }
    },
    removePromotion() {
      this.promotionList = [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
        },
      ];
      this.designatedSku = [];
    },
    getMemberFn(val) {
      if (val == 2) {
        this.ruleDTO.activityScene = 2;
      }
    },
    // 背景图上传校验
    async beforeUploadUI(file, type) {
      // let sizeype = {
      //   1: {
      //     width: 702,
      //     height: 523,
      //   },
      //   2: {
      //     width: 146,
      //     height: 52,
      //   },
      //   3: {
      //     width: 702,
      //     height: 863,
      //   },
      //   4: {
      //     width: 708,
      //     height: 141,
      //   },
      //   5: {
      //     width: 702,
      //     height: 643,
      //   },
      // };
      // const status = await this.imgchecked(
      //   file,
      //   sizeype[type].width,
      //   sizeype[type].height
      // );
      // if (!status) {
      //   return false;
      // }
    },
    // 背景图上传图片
    handleUploadUI(res, type) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (type == 1) {
          this.customerPaperwork.memberModelUrl = res.data;
        } else if (type == 2) {
          this.customerPaperwork.memberBtnUrl = res.data;
        } else if (type == 3) {
          this.customerPaperwork.prizeModelUrl = res.data;
        } else if (type == 4) {
          this.customerPaperwork.stepTabUrl = res.data;
        } else if (type == 5) {
          this.customerPaperwork.trialModelUrl = res.data;
        }
        this.$message.success("背景图上传成功");
      }
    },
    getPrizeCommon(data, prizeType) {
      //处理奖品返回字段公共部分
      let prizeObj = {
        price: "",
        assetsId: "",
        logo: "",
        prizeType: "",
        title: "",
      };
      if (prizeType == 1) {
        prizeObj.couponType = data.couponType;
      }
      if (data.giftType) {
        prizeObj.giftType = Number(data.giftType);
      }
      prizeObj.price = Number(data.discount);

      prizeObj.assetsId = data.couponId ? Number(data.couponId) : data.skuId;
      prizeObj.logo = data.logo || this.defaultLogo;
      prizeObj.prizeType = prizeType;

      if (prizeType == 4) {
        prizeObj.title = data.discount + "店铺积分";
      } else {
        prizeObj.title = data.name;
      }

      if (data.singleAmount) {
        prizeObj.singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        prizeObj.quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          prizeObj.skuId = data.skuId;
          delete prizeObj.isGoodManage;
        } else {
          prizeObj.isGoodManage = data.isGoodManage;
        }
        prizeObj.predictSendTime = data.predictSendTime;
        prizeObj.isFollowActivityEndTime = data.isFollowActivityEndTime ? data.isFollowActivityEndTime : 0;
        prizeObj.addressFillEndTime = data.addressFillEndTime;
        prizeObj.shouldCollectExtraData = data.shouldCollectExtraData;
        prizeObj.extraQuestion = data.extraQuestion;
        prizeObj.addressFillLimit = data.addressFillLimit;
        prizeObj.commitAddressLimit = data.commitAddressLimit;
      }
      // 实物随单发
      if (prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(prizeObj,prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      return prizeObj;
    },
    getTheData(data, prizeType) {
      if (this.showSelectProduct) {
        // 抽奖奖品
        const prizeObj = this.getPrizeCommon(data, prizeType);
        this.$set(this.prizeList, this.tableIndex, prizeObj);
        this.showSelectProduct = false;
      } else {
        // 阶梯奖品
        this.$set(
          this.prizeList[this.currentIndex].goodsList,
          this.prizeIndex,
          this.getPrizeCommon(data, prizeType)
        );
        this.isShowPrize = false;
      }
    },
    getStepTheData(data, prizeType) {
      // 阶梯奖品
      this.$set(
        this.repurchaseStages[this.rankValue].stepPrizeList[this.stepPrizeIndex]
          .goodsList,
        0,
        this.getPrizeCommon(data, prizeType)
      );
      this.isShowStepPrize = false;
    },
    confirmAdd(num) {
      if (this.currentPrizeIndex >= 0) {
        this.$set(
          this.repurchaseStages[this.stockIndex].stepPrizeList[
            this.currentPrizeIndex
          ].goodsList[0],
          "totalAmount",
          Number(num)
        );
      } else {
        this.$set(
          this.prizeList[this.stockPrizeIndex],
          "totalAmount",
          Number(num)
        );
      }
      this.isShowAddNum = false;
    },
    // 京东计划数量计算
    prizeNum(row) {
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },
    checkputn(e, row = {}) {
      if (
        row.quantityTotal &&
        row.price &&
        row.totalAmount &&
        row.prizeType == 2
      ) {
        let numTotal = this.$jingdouTotal({
          ...row,
          prizeCount: row.totalAmount,
        });
        if (!numTotal) {
          this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
        }
        return numTotal;
      } else {
        return row.totalAmount;
      }
    },

    initCustomizeData(row) {
      let configJson = row.configJson ? JSON.parse(row.configJson) : {};
      this.customerPaperwork.titleColor = row.rgb;
      this.customerPaperwork.memberWordColor = row.rgb2;
      this.customerPaperwork.memberBtnWordColor = row.rgb2;
      this.customerPaperwork.modelWordColor = configJson.rgb4 || '';
      this.customerPaperwork.progressLeftColor = configJson.rgb5 || '';
      this.customerPaperwork.progressMiddleColor = configJson.rgb6 || '';
      this.customerPaperwork.progressRightColor = configJson.rgb7 || '';
      this.customerPaperwork.memberModelUrl = row.imageUrl;
      // 使用 $set 确保响应式更新
      this.$set(this.customerPaperwork, 'memberBtnUrl', row.url2 || '');
      this.currrentRgb = row.rgb;
      this.currrentRgb2 = row.rgb2;
      this.currrentRgb3 = row.rgb3;
      this.currrentRgb4 = configJson.rgb4;
      this.currrentRgb5 = configJson.rgb5;
      this.currrentRgb6 = configJson.rgb6;
      this.currrentRgb7 = configJson.rgb7;
    },
    selectTemplate(index, id, item) {
      console.log(item,'55555555');
      console.log('url2:', item.url2);
      
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      // 选择模板时重置上传的背景图
      this.uploadBgImage = "";
      // 确保响应式更新预览组件
      this.$set(this.customerPaperwork, 'memberBtnUrl', item.url2 || '');
      this.initCustomizeData(item);
    },
    // 处理背景图变化
    handleBgImageChange(obj) {
      this.uploadBgImage = obj.activityBgImg || "";
    },
    onShopSetChange(value) {
      this.ruleDTO.goShopAppId = "";
      this.ruleDTO.goShopUrl = "";
    },

    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    // 京东计划数量计算
    prizeNum(row) {
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },
    // 活动进行中修改奖品数量
    beAdd(row) {
      if (this.activityData.isStart) {
        if (row.totalAmount < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.error("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
              return {
                ...item,
                days: item.activityStartTime
                  ? this.getDaysBetween(
                      item.activityStartTime,
                      item.activityEndTime
                    )
                  : "",
              };
            })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        this.templateObj = this.giftList[0];
        this.templateId = this.giftList[0].id;
        this.templateJson.templateUItype = 0;
        this.initCustomizeData(this.templateObj);
      } else if (this.templateId) {
        let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.templateObj = arr[0];
        this.templateId = this.templateId;
        let configJson =
          this.templateObj.configJson &&
          JSON.parse(this.templateObj.configJson);
        this.currrentRgb = this.templateObj.rgb;
        // 只有当用户没有自定义颜色时才使用模板默认值
        if (!this.customerPaperwork.memberBtnWordColor) {
          this.customerPaperwork.memberBtnWordColor = this.templateObj.rgb2;
        }
        this.currrentRgb2 = this.templateObj.rgb2;
        this.currrentRgb3 = this.templateObj.rgb3;
        this.currrentRgb4 = configJson.rgb4;
        this.currrentRgb5 = configJson.rgb5;
        this.currrentRgb6 = configJson.rgb6;
        this.currrentRgb7 = configJson.rgb7;
        this.customerPaperwork.titleColor = this.customerPaperwork.titleColor;
        this.customerPaperwork.memberWordColor =
          this.customerPaperwork.memberWordColor;
        this.customerPaperwork.memberBtnWordColor =
          this.customerPaperwork.memberBtnWordColor;
        // 只有当用户没有自定义按钮背景图时才使用模板默认值
        if (!this.customerPaperwork.memberBtnUrl) {
          this.$set(this.customerPaperwork, 'memberBtnUrl', this.templateObj.url2 || '');
        }
        this.customerPaperwork.modelWordColor =
          this.customerPaperwork.modelWordColor;
        this.customerPaperwork.progressLeftColor =
          this.customerPaperwork.progressLeftColor;
        this.customerPaperwork.progressMiddleColor =
          this.customerPaperwork.progressMiddleColor;
        this.customerPaperwork.progressRightColor =
          this.customerPaperwork.progressRightColor;
      }
      this.pageData.total = data.total * 1;
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {
          console.error(res);
        });
    },
    //生成规则
    generateRule() {
      let text6 = "",
        text7 = "",
        text8 =
          "",
        text9 = "",
        secondText = "\n二、【活动参与规则】",
        thirdText = "\n三、【活动奖品】",
        fifthText = "\n四、【注意事项】";
      const {firstText,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleDTO,this.actMember,false,true)
      //参与规则
      let arr = []
      let text = ""
      let text2 = ""
      // 购物车锦鲤活动参与规则
      const drawLimit = Number(this.ruleForm.drawLimit) || 0
      let drawTime = ''
      if (this.ruleForm.drawTime) {
        try {
          const date = new Date(this.ruleForm.drawTime)
          if (!isNaN(date.getTime())) {
            drawTime = this.formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          } else {
            drawTime = this.ruleForm.drawTime
          }
        } catch (e) {
          drawTime = this.ruleForm.drawTime
        }
      }
      text = `在活动时间范围内成功将${drawLimit}件指定商品加入购物车即可获取抽奖机会`
      arr.push(text)
      text2 = `开始抽奖时间：${drawTime}后即可进行抽奖`
      arr.push(text2)

      // 活动奖品 - 购物车锦鲤活动使用prizeList
      if (this.prizeList && this.prizeList.length > 0) {
        let prizeArr = [];
        this.prizeList.forEach((item, index) => {
          if (item.title) {
            prizeArr.push(`奖品${index + 1}：${item.title}，共 ${item.totalAmount || 0} 份，单份奖品价值 ${item.price || 0} 元`);
          }
        });
        if (prizeArr.length > 0) {
          text6 = prizeArr.join('\n    ') ;
        }
        text7 = '所有奖品数量有限，先到先得，送完即止。';
      }
      let Arr1 = [
        firstText,
        [secondText, ...arr],
        [thirdText, text6, text7, text8],
        [text9],
        [fifthText,precautions]
      ];
      let newText = "";

      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText.trim();
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },

    // 下一步
    resetForm() {
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      //开奖时间的限制：必须在活动时间范围内，且需早于活动结束时间10分钟
      if (!this.ruleForm.drawTime) {
        this.$message.warning("请选择开奖时间");
        return;
      }
      const startTime = new Date(this.ruleForm.startTime).getTime();
      const endTime = new Date(this.ruleForm.endTime).getTime();
      const tenMinutes = 10 * 60 * 1000;
      const drawTime = new Date(this.ruleForm.drawTime).getTime();
      if (drawTime < startTime) {
        this.$message.warning("开奖时间不能小于活动开始时间");
        return;
      }
      if (drawTime > endTime - tenMinutes) {
        this.$message.warning("开奖时间需早于活动结束时间10分钟");
        return;
      }
      //活动对象限制
      if (
        this.actMember == 2 &&
        (!this.ruleForm.partner || this.ruleForm.partner.length == 0)
      ) {
        this.$message.warning("请选择活动对象");
        return;
      }
      if (this.actMember == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }

      // 1.14迭代 这里判断 指定入会时间
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType == 1 &&
          !this.ruleForm.openCardBeforeDay
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        if (
          this.ruleForm.firstOpenCardTimeType == 2 &&
          (!this.ruleDTO.openCardStartTime || !this.ruleDTO.openCardEndTime)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        // 最后一次订单完成时间
        if (
          this.ruleForm.lastOrderCompleteTimeType == 1 &&
          !this.ruleForm.lastOrderCompleteEndDay &&
          !this.ruleForm.lastOrderCompleteStartDay
        ) {
          return this.$message.warning("最后一次订单完成时间");
        }

        if (
          this.ruleForm.lastOrderCompleteTimeType == 2 &&
          !this.ruleForm.lastOrderCompleteStartTime &&
          !this.ruleForm.lastOrderCompleteEndTime
        ) {
          return this.$message.warning("最后一次订单完成时间");
        }
      }

      if (!this.templateId) {
        return this.$message.warning("请选择活动模板");
      }
      // 公活动配置校验
      // if (!useValidateMoreActSet(this)) {
      //   return;
      // }

      if(this.placementPosition.length==0) {
        this.$message.warning("请选择活动投放位置！");
        return
      }

      //新增进店设置校验
      if (this.ruleDTO.goShopSetting == 1 && !this.ruleDTO.goShopAppId) {
        this.$message.warning("请输入小程序appId");
        return;
      }
      if (this.ruleDTO.goShopSetting == 2) {
        if (!this.ruleDTO.goShopUrl) {
          this.$message.warning("请输入指定链接");
          return;
        } else if (
          !this.ruleDTO.goShopUrl.startsWith("https://") ||
          !this.ruleDTO.goShopUrl.includes("jd.com")
        ) {
          this.$message.warning(
            "输入的内容非链接或为接口无法支持的链接，请重新设置"
          );
          return;
        }
      }
      // 小程序分享标题
      if (!this.ruleDTO.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleDTO.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      if (this.ruleForm.isExposureItem && this.itemListFor.length == 0) {
        this.$message.warning("请选择曝光商品");
        return;
      }
      // 加购商品数量校验
      if (this.cartItemList.length == 0) {
        this.$message.warning("请至少选择一个加购商品");
        return;
      }
      if (this.cartItemList.length > 100) {
        this.$message.warning("加购商品最多可选择 100 个");
        return;
      }
      // 默认解锁商品件数校验
      if (!this.ruleForm.defaultUnlockNum) {
        this.$message.warning("请输入默认解锁商品数量");
        return;
      }
      if (!Number.isInteger(this.ruleForm.defaultUnlockNum) || this.ruleForm.defaultUnlockNum < 1) {
        this.$message.warning("默认解锁商品数量必须为正整数");
        return;
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    async handleDialogCloseAnoth() {
      // 构建奖品列表
      let prizeList = this.prizeList.map((item, index) => ({
        ...item,
        prizeObjectType: 0,
        taskIndex: index + 1,
      }));

      // 格式化开奖时间
      let formattedDrawTime = '';
      if (this.ruleForm.drawTime) {
        try {
          const date = new Date(this.ruleForm.drawTime);
          if (!isNaN(date.getTime())) {
            formattedDrawTime = this.formatDate(date, 'yyyy-MM-dd hh:mm:ss');
          } else {
            formattedDrawTime = this.ruleForm.drawTime;
          }
        } catch (e) {
          formattedDrawTime = this.ruleForm.drawTime;
        }
      }

      let ruleDTO = {
        ...this.ruleDTO,
        defaultUnlockNum: this.ruleForm.defaultUnlockNum,
        assistUnlockNum: this.ruleForm.assistUnlockNum,
        assistLimitType: this.ruleForm.assistLimitType,
        drawLimit: this.ruleForm.drawLimit,
        drawTime: formattedDrawTime,
        drawType: this.ruleForm.lotteryConfig,
        // 加购商品集合 - 转换为skuId数组
        addShopCartSkuIds: this.cartItemList.map(item => item.skuId),
      };

      let obj = {
        ...this.ruleForm,
        subType: 77,
        ruleDTO,
        pointActivityPrizeDTOList: prizeList.filter((item) => item.prizeType > 0),
      };

      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.ruleDTO.openCardStartTime =
        this.actMember == 2 ? this.ruleDTO.openCardStartTime : "";
      obj.ruleDTO.openCardEndTime =
        this.actMember == 2 ? this.ruleDTO.openCardEndTime : "";
      obj.ruleDTO.plusObject = this.ruleDTO.plusObject;
      // 开卡入会后方可参与活动
      obj.ruleDTO.openCardFollow = this.ruleForm.openCardFollow;
      // 其他活动页配置
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);

      // 强提醒
      obj.ruleDTO.isForceRemind = this.ruleDTO.isForceRemind;
      // 是否重点活动
      obj.isKeyActivity = this.isKeyActivity;
      // 活动投放位置
      obj.placementPosition = this.placementPosition.join(",");

      //曝光商品集合设置
      obj.priceType = 0;
      obj.isExposureItem = this.ruleForm.isExposureItem ? 1 : 0;
      obj.itemList = this.itemListFor;

      // 模板
      obj.templateJson = this.templateJson;
      obj.templateId = this.templateId;

      // 活动对象处理
      // 参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      obj.allowLevel =
        this.ruleForm.partner && this.ruleForm.partner.length
          ? this.ruleForm.partner.join(",")
          : "";

      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel =
          this.ruleForm.partner && this.ruleForm.partner.length
            ? this.ruleForm.partner.join(",")
            : "";
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
      }
      obj.ruleDTO.orderCompleteLimitCount =
        this.ruleForm.orderCompleteLimitCount;
      obj.ruleDTO.orderCompleteMaxCount = this.ruleForm.orderCompleteMaxCount;
      obj.ruleDTO.orderCompleteLimitPayment =
        this.ruleForm.orderCompleteLimitPayment;
      obj.ruleDTO.orderCompleteMaxPayment =
        this.ruleForm.orderCompleteMaxPayment;
      obj.ruleDTO.lastOrderCompleteTimeType =
        this.ruleForm.lastOrderCompleteTimeType;
      if (obj.ruleDTO.lastOrderCompleteTimeType == 1) {
        obj.ruleDTO.lastOrderCompleteStartDay =
          this.ruleForm.lastOrderCompleteStartDay;
        obj.ruleDTO.lastOrderCompleteEndDay =
          this.ruleForm.lastOrderCompleteEndDay;
      } else if (obj.ruleDTO.lastOrderCompleteTimeType == 2) {
        obj.ruleDTO.lastOrderCompleteStartTime =
          this.ruleForm.lastOrderCompleteStartTime;
        obj.ruleDTO.lastOrderCompleteEndTime =
          this.ruleForm.lastOrderCompleteEndTime;
      }
      // delete obj.partner;
      // delete obj.openCardFollow;
      // delete obj.firstOpenCardTimeType;
      // delete obj.openCardBeforeDay;
      // delete obj.orderCompleteLimitCount;
      // delete obj.orderCompleteMaxCount;
      // delete obj.orderCompleteLimitPayment;
      // delete obj.orderCompleteMaxPayment;
      // delete obj.lastOrderCompleteTimeType;
      // delete obj.lastOrderCompleteStartDay;
      // delete obj.lastOrderCompleteEndDay;
      // delete obj.lastOrderCompleteStartTime;
      // delete obj.lastOrderCompleteEndTime;
      if (this.checked == true || this.isDraft) {
        this.saveLoading = true;
        if (this.activityData.isStart) {
          let params = {
            activityId: this.valueRow.id,
            ruleDescription: obj.ruleDescription,
            prizes: prizeList.map((item) => {
              const prize = {
                ...item,
                prizeId: item.id,
                title:item.title,
              };
              // 提交地址限制：数组转逗号分隔字符串
              if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
                prize.commitAddressLimit = item.commitAddressLimit.join(',');
              }
              return prize;
            }),
            isExposureItem: this.ruleForm.isExposureItem ? 1 : 0, //曝光商品
            itemList: this.ruleForm.isExposureItem ? this.itemListFor : [],
            activityName: obj.activityName,
            condFollow: obj.condFollow ? 1 : 0,
            ruleDto: obj.ruleDTO,
            templateId: this.templateId,
            endTime: this.ruleForm.endTime,
          };
          updateCommon(params)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
                console.error(res);
                this.saveLoading = false;
            });
        } else {
          if (this.isDraft) {
            obj.status = 5;
            delete obj.templateJson;
          } else {
            // 保存正式活动不需要status
            if (obj.status) delete obj.status;
            if (!this.activityData.isCopy) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
                obj.id = this.valueRow.id;
              }
            } else {
              delete obj.templateJson;
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
          }
          saveOrUpdateShoppingCartKoi(obj)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              console.error(res);
              this.saveLoading = false;
            });
        }
      } else {
        this.saveLoading = false;
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        this.loading = true;
        getActivityDetailCommon(this.valueRow.id)
          .then((res) => {
            const {
              activityName,
              startTime,
              endTime,
              ruleDto,
              isExposureItem,
              ruleDescription,
              allowLevel,
              crowdIds,
              condFollow,
              templateId,
              pointActivityPrizeDTOList,
              studentSatus,
            } = res.data;
            this.ruleForm.activityName =
              activityName + (this.activityData.isCopy ? "复制" : "");

            this.ruleForm.condFollow = condFollow ? true : false;
            // 活动对象配置
            if (allowLevel == "99") {
              this.peopleSelected = crowdIds.split(",");
              this.actMember = "3";
            } else if (allowLevel == "-1") {
              this.actMember = "1";
              this.ruleForm.partner = ["-1"];
            } else {
              this.actMember = "2";
              if (allowLevel.indexOf("-1") != -1) {
                this.ruleForm.partner = ["-1"];
              } else {
                this.ruleForm.partner = allowLevel.split(",");
              }
            }
            this.ruleDTO = ruleDto;
            this.ruleForm.orderCompleteLimitCount =
              ruleDto.orderCompleteLimitCount;
            this.ruleForm.orderCompleteMaxCount = ruleDto.orderCompleteMaxCount;
            this.ruleForm.orderCompleteLimitPayment =
              ruleDto.orderCompleteLimitPayment;
            this.ruleForm.orderCompleteMaxPayment =
              ruleDto.orderCompleteMaxPayment;
            this.ruleForm.lastOrderCompleteTimeType =
              ruleDto.lastOrderCompleteTimeType || 0;
            this.ruleForm.lastOrderCompleteStartDay =
              ruleDto.lastOrderCompleteStartDay;
            this.ruleForm.lastOrderCompleteEndDay =
              ruleDto.lastOrderCompleteEndDay;
            this.ruleForm.lastOrderCompleteStartTime =
              ruleDto.lastOrderCompleteStartTime;
            this.ruleForm.lastOrderCompleteEndTime =
              ruleDto.lastOrderCompleteEndTime;

            if (ruleDto.customerPaperwork) {
              this.customerPaperwork = JSON.parse(ruleDto.customerPaperwork);
            }
            // 强提醒
            if (ruleDto.isForceRemind !== undefined) {
              this.ruleDTO.isForceRemind = ruleDto.isForceRemind;
            }
            // 是否重点活动
            if (res.data.isKeyActivity !== undefined) {
              this.isKeyActivity = res.data.isKeyActivity;
            }
            // 活动投放位置
            this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(",") : ["SHOP"];
            // 学生身份
            this.ruleForm.studentSatus = studentSatus || "";
            // if(this.ruleForm.joinType==0) {
            //   this.ruleForm.joinStartTime = joinStartTime;
            //   this.ruleForm.joinEndTime = joinEndTime;
            //   if (joinStartTime && joinEndTime) {
            //     this.isSignLimitTime = true;
            //   }
            // }
            this.templateId = templateId;
            this.getPolite();

            this.loading = false;

            // 活动时间回显（复制时也需要）
            this.ruleForm.startTime = startTime;
            this.ruleForm.endTime = endTime;
            this.activityStartTime = startTime;
            this.activityEndTime = endTime;

            this.ruleForm.isExposureItem = isExposureItem ? true : false;
            this.itemListFor = res.data.itemList;

            // 加购商品回显 - 从ruleDto.addShopCartSkuIds获取（复制时也需要）
            if (ruleDto.addShopCartSkuIds && ruleDto.addShopCartSkuIds.length > 0) {
              // 调用getSkuList获取商品详情
              getSkuList({
                skuId: ruleDto.addShopCartSkuIds.join(','),
                current: 1,
                size: 999,
              }).then(res => {
                if (res.code == 1) {
                  const skuMap = {};
                  res.data.records.forEach(item => {
                    skuMap[item.skuId] = item;
                  });
                  this.cartItemList = ruleDto.addShopCartSkuIds.map(skuId => {
                    const skuInfo = skuMap[skuId] || {};
                    return {
                      skuId: skuId,
                      logo: skuInfo.logo || '',
                      price: skuInfo.price || '',
                      title: skuInfo.title || ''
                    };
                  });
                  this.cartMainImagelist = [...this.cartItemList];
                }
              });
            } else {
              this.cartItemList = [];
              this.cartMainImagelist = [];
            }

            // 使用ruleDto而不是res.data.ruleDTO（复制时也需要）
            this.ruleForm.openCardFollow = ruleDto.openCardFollow || 0;
            this.ruleForm.defaultUnlockNum = ruleDto.defaultUnlockNum || "";
            this.ruleForm.assistUnlockNum = ruleDto.assistUnlockNum || "";
            this.ruleForm.assistLimitType = ruleDto.assistLimitType || 0;
            this.ruleForm.drawLimit = ruleDto.drawLimit || "";
            this.ruleForm.drawTime = ruleDto.drawTime || "";
            this.ruleForm.lotteryConfig = ruleDto.drawType || 0;

            // 奖品列表回显 - 复制时不显示奖品
            if (this.activityData.isCopy) {
              this.prizeList = [];
            } else {
              this.prizeList = (pointActivityPrizeDTOList || []).map(item => {
                const prizeItem = {
                  ...item,
                  // 兼容旧字段winningRate，优先使用percentage
                  percentage: item.percentage
                };
                // 提交地址限制回显：逗号分隔字符串转数字数组
                if (item.prizeType == 3) {
                  if (item.commitAddressLimit) {
                    prizeItem.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                      ? item.commitAddressLimit.split(',').map(Number)
                      : item.commitAddressLimit;
                  } else {
                    prizeItem.commitAddressLimit = [0];
                  }
                }
                return prizeItem;
              });
            }

            // 规则描述：复制时清空，编辑时回显
            this.ruleForm.ruleDescription = this.activityData.isCopy ? "" : ruleDescription;

            this.templateJson = JSON.parse(res.data.templateJson);
          })
          .catch((res) => {
            console.error(res);
          });
      } else {
        this.activityStartTime = this.$getDate(30)[0];
        this.activityEndTime = this.$getDate(30)[1];
        this.hdTaskTemplateGroup();
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
  }

  .logo-style {
    margin-top: 8px;
    width: 90px;
    height: 90px;
  }
  .setting-box {
    background: #fafafa;
    padding: 10px;
    border-radius: 4px;
  }
  .prize-logo {
    width: 56px;
    height: 56px;
    margin-top: 8px;
  }
  .ml8 {
    margin-left: 8px;
    color: #565960;
  }
  .ml12 {
    margin-left: 12px;
  }
  .ml20 {
    margin-left: 30px;
  }
  .mr8 {
    margin-right: 8px;
  }
  .mt12 {
    margin-top: 12px;
  }
  .mb12 {
    margin-bottom: 12px;
  }
  .w90 {
    width: 90px;
  }
  .w380 {
    width: 380px;
  }
  .tips_red {
    color: #ff4d4f;
  }
  .buttonGroup {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #666;
  }
  .prize_box {
    background: #fafafa;
    padding: 16px;
    border-radius: 4px;
    &_middle {
      padding-top: 10px;
    }
    &_step {
      margin-top: 16px;
      &_top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4px 10px;
        background-color: #f0f2f7;
        &__delete {
          cursor: pointer;
        }
      }
      &_center {
        background-color: #fff;
        padding: 10px 0px;
      }
    }
  }

  .prize-set {
    position: relative;
    background-color: #fff;
    padding: 16px;
    border-radius: 4px;
    .delete-icon {
      position: absolute;
      top: 16px;
      right: 16px;
      font-size: 18px;
      cursor: pointer;
      &:hover {
        color: #ff4d4f;
      }
    }
  }
  .specified-box {
    background-color: #e6e6e6;
    padding: 16px;
    border-radius: 4px;
  }
  .btn-bg {
    margin-top: 5px;
    width: 80px;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .prize-item {
    width: 80px;
    height: 80px;
    position: relative;
    margin-right: 16px;
    .prize-img {
      width: 100%;
      height: 100%;
      border-radius: 4px;
    }
    .del-icon {
      position: absolute;
      right: -8px;
      top: -8px;
      width: 20px;
      height: 20px;

      cursor: pointer;
    }
  }
  .ui-box {
    width: fit-content;
    border-radius: 4px;
  }
}
.goToMeasureUnitText{
  color: #3159FF;
  cursor: pointer;
}
.flex-center {
  display: flex;
  align-items: center;
}
</style>
